import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import config from './config';

/*
 ** @description PRepare data for API
 ** @param Object user_id, roster
 ** @returns object
 */
const handlePrepareData = ({ user_id, roster }) => ({
  user_id,
  roster_id: roster.key
});

const ICal = ({ objectId, permissions }) => (
  <Inner
    canAdmin={permissions.CanAdminICal()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.icalItem,
      list: REDUCER_KEY.icalItems
    }}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          user__id: [objectId]
        },
        commands: {
          showAdd: false,
          showDelete: false
        }
      },
      detail: {
        ...config.detail,
        filters: {
          user__id: [objectId]
        },
        parent: {
          user_id: objectId
        }
      }
    }}
    messaging={{
      delete: {
        disabled: () => 'Item Disabled.',
        failure: error => `Delete Failed. ${error}`,
        success: () => 'Delete Successful.'
      },
      save: {
        failure: () => 'Saving failed',
        success: () => 'Saving was successful'
      }
    }}
    onPrepareData={handlePrepareData}
  />
);

ICal.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

ICal.defaultProps = {
  objectId: null
};

export default ICal;
